import Vue from "vue";
import app from "@/main";

function initialState() {
	return {
		editMode: false,
		markers: {},
		spiderfier: null,
		activeMarker: {
			id: null,
			type: null
		},
		rootActiveMarker: {
			id: null,
			type: null
		},
		detailsSidebar: app.$vuetify.breakpoint.mdAndUp,
		alerts: app.$vuetify.breakpoint.mdAndUp,
		autoFollow: false,
		followable: false,
		history: true,
		mapCenter: {
			lat: 36.115614,
			lng: -97.049664
		},
		mapZoom: 9,
		sidebar: app.$vuetify.breakpoint.mdAndUp,
		traffic: false
	};
}

export default {
	namespaced: true,

	state: initialState,

	getters: {
		hasActiveMarker( store ) {
			return Boolean(
				store.rootActiveMarker
				&& store.rootActiveMarker.id
				&& store.rootActiveMarker.type
			);
		}
	},

	actions: {
		reset( store ) {
			const initial = initialState();

			Object.keys( initial ).forEach( key => store.state[key] = initial[key] );
		},

		setEditMode( { commit }, editMode ) {
			commit( "SET_EDIT_MODE", Boolean( editMode ) );
		},

		setSpiderfier( { commit }, spiderfier ) {
			commit( "SET_SPIDERFIER", spiderfier );
		},

		addMarker( store, markerData ) {
			if ( store.state.spiderfier
				&& markerData.marker
				&& markerData.marker.$markerObject
			) {
				store.state.spiderfier.trackMarker( markerData.marker.$markerObject );
			}

			store.commit( "ADD_MARKER", markerData );
		},

		setActiveMarker( { commit }, markerData ) {
			if ( !markerData ) {
				markerData = {};
			}

			commit( "SET_ACTIVE_MARKER", markerData );
		},

		setRootActiveMarker( { commit }, markerData ) {
			if ( !markerData ) {
				markerData = {};
			}

			commit( "SET_ACTIVE_MARKER", markerData );
			commit( "SET_ROOT_ACTIVE_MARKER", markerData );
		},

		setDetailsSidebar( { commit }, visible ) {
			commit( "SET_DETAILS_SIDEBAR", Boolean( visible ) );
		},

		setAlerts( { commit }, visible ) {
			commit( "SET_ALERTS", Boolean( visible ) );
		},

		setAutoFollow( { commit }, follow ) {
			commit( "SET_AUTO_FOLLOW", Boolean( follow ) );
		},

		setFollowable( { commit }, followable ) {
			commit( "SET_FOLLOWABLE", Boolean( followable ) );
		},

		setHistory( { commit }, visible ) {
			commit( "SET_HISTORY", Boolean( visible ) );
		},

		setMapCenter( { commit }, center ) {
			if ( center.lat ) {
				center.lat = parseFloat( center.lat.toFixed( 6 ) );
			}

			if ( center.lng ) {
				center.lng = parseFloat( center.lng.toFixed( 6 ) );
			}

			commit( "SET_MAP_CENTER", center );
		},

		setMapZoom( { commit }, zoom ) {
			commit( "SET_MAP_ZOOM", zoom );
		},

		setSidebar( { commit }, visible ) {
			commit( "SET_SIDEBAR", Boolean( visible ) );
		},

		setTraffic( { commit }, visible ) {
			commit( "SET_TRAFFIC", Boolean( visible ) );
		}
	},

	mutations: {
		ADD_MARKER( store, { markerId, marker } ) {
			Vue.set( store.markers, markerId, marker );
		},

		SET_EDIT_MODE( store, value ) {
			store.editMode = value;
		},

		SET_SPIDERFIER( store, spiderfier ) {
			store.spiderfier = spiderfier;
		},

		SET_ACTIVE_MARKER( store, { id, type } ) {
			store.activeMarker = {
				id,
				type
			};
		},

		SET_ROOT_ACTIVE_MARKER( store, { id, type } ) {
			store.rootActiveMarker = {
				id,
				type
			};
		},

		SET_DETAILS_SIDEBAR( store, visible ) {
			store.detailsSidebar = visible;
		},

		SET_ALERTS( store, visible ) {
			store.alerts = visible;
		},

		SET_AUTO_FOLLOW( store, follow ) {
			store.autoFollow = follow;
		},

		SET_FOLLOWABLE( store, followable ) {
			store.followable = followable;
		},

		SET_HISTORY( store, visible ) {
			store.history = visible;
		},

		SET_MAP_CENTER( store, center ) {
			store.mapCenter = center;
		},

		SET_MAP_ZOOM( store, zoom ) {
			store.mapZoom = zoom;
		},

		SET_SIDEBAR( store, visible ) {
			store.sidebar = visible;
		},

		SET_TRAFFIC( store, visible ) {
			store.traffic = visible;
		}
	}
};
